import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout } from "antd";
import { Header, Footer, Homepage } from "./components";
import Application from "./pages/Application";
import Application1 from "./pages/Application1";
import Application2 from "./pages/Application2";
import Application3 from "./pages/Application3";
import Application4 from "./pages/Application4";
import Application5 from "./pages/Application5";
import Application6 from "./pages/Application6";
import Application7 from "./pages/Application7";
import Application8 from "./pages/Application8";
import Confirmation from "./pages/Confirmation";
import AboutProgram from "./pages/AboutProgram";
import ApplicationStatus from "./pages/ApplicationStatus";
import BikeShops from "./pages/BikeShops";
import FAQs from "./pages/FAQs";
import ContactUsConsumer from "./pages/ContactUsConsumer";
import "./App.css";

const { Content } = Layout;

function App() {
  return (
    <Router>
      <Layout className="app-layout">
        <Header />
        <Content className="app-content">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/application" element={<Application />} />
            <Route path="/application1" element={<Application1 />} />
            <Route path="/application2" element={<Application2 />} />
            <Route path="/application3" element={<Application3 />} />
            <Route path="/application4" element={<Application4 />} />
            <Route path="/application5" element={<Application5 />} />
            <Route path="/application6" element={<Application6 />} />
            <Route path="/application7" element={<Application7 />} />
            <Route path="/application8" element={<Application8 />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/about" element={<AboutProgram />} />
            <Route path="/status" element={<ApplicationStatus />} />
            <Route path="/shops" element={<BikeShops />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<ContactUsConsumer />} />
          </Routes>
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
}

export default App;
